<template>
    <div>
        <section class="pro-details padding-top padding-bottom">
            <div class="container">
                <div class="pro-details__wrapper">
                    <div class="pro-details__block mb-4">
                        <div class="pro-details__block-inner">
                            <div class="row g-5 align-items-center">
                                <div class="col-lg-4">
                                    <div class="pro-details__item-wrap">
                                        <div class="pro-details__item">
                                            <div class="">
                                                <img :src="`/assets/images/dragons/avatar/${dragon.name}_Dragon.png`"
                                                    width="90" :alt="`${dragon.name}`" @error="getErrorImg" />
                                            </div>
                                            <div class="pro-details__item-content">
                                                <h4>{{ dragon.name.replaceAll('_', ' ') }}
                                                    <span>
                                                        <img :src="`/assets/images/type/${dragon.type}.png`" width="25"
                                                            :alt="`${dragon.type}`" />
                                                    </span>
                                                </h4>
                                                <p>
                                                    <span v-for="(element, e_idx) in dragon.elements" :key="e_idx">
                                                        <img :src="`/assets/images/elements/${element}.png`"
                                                            :alt="`${element}`" width="40" />
                                                    </span>
                                                </p>
                                            </div>
                                            <div class="btn-group mt-4 d-flex flex-wrap gap-20">
                                                <router-link :to="`/how-to-get/${dragon.name}`"
                                                    class="default-btn default-btn--small">
                                                    <span>How to get</span>
                                                </router-link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-8">
                                    <div class="pro-details__info">
                                        <div class="row g-2">
                                            <div class="col-sm-4">
                                                <div class="pro-details__info-item">
                                                    <h6 class="pro-details__info-name">
                                                        Base Attack
                                                    </h6>
                                                    <p class="pro-details__info-value">
                                                        <img alt="Dragon Attack" src="/assets/images/common/attack.png"
                                                            width="22"> {{ getBaseAttack(dragon) }}
                                                    </p>
                                                </div>
                                            </div>
                                            <div class="col-sm-4">
                                                <div class="pro-details__info-item">
                                                    <h6 class="pro-details__info-name">
                                                        Base Health
                                                    </h6>
                                                    <p class="pro-details__info-value">
                                                        <img alt="Dragon Health"
                                                            src="/assets/images/common/breeding.png" width="22">
                                                        {{ getBaseHP(dragon) }}
                                                    </p>
                                                </div>
                                            </div>
                                            <div class="col-sm-4">
                                                <div class="pro-details__info-item">
                                                    <h6 class="pro-details__info-name">
                                                        Base Gold
                                                    </h6>
                                                    <p class="pro-details__info-value">
                                                        <img alt="Dragon Gold" src="/assets/images/common/Gold_Icon.png"
                                                            width="22"> {{ getBaseGold(dragon) }}
                                                    </p>
                                                </div>
                                            </div>
                                            <div class="col-sm-4">
                                                <div class="pro-details__info-item">
                                                    <h6 class="pro-details__info-name">
                                                        Obtain Method
                                                    </h6>
                                                    <p class="pro-details__info-value">
                                                        {{ dragon.obtain_method }}
                                                    </p>
                                                </div>
                                            </div>
                                            <div class="col-sm-4">
                                                <div class="pro-details__info-item">
                                                    <h6 class="pro-details__info-name">
                                                        Breed Time
                                                    </h6>
                                                    <p class="pro-details__info-value">
                                                        <img alt="Dragon Breed Time" src="/assets/images/common/egg.png"
                                                            width="22"> {{ splitTime(getBaseBreed(dragon)) }}
                                                        / <img alt="Dragon Breed Time"
                                                            src="/assets/images/common/vip_status.png" width="22"> {{
                                                        splitTime(getBaseBreed(dragon, true)) }}
                                                    </p>
                                                </div>
                                            </div>
                                            <div class="col-sm-4">
                                                <div class="pro-details__info-item">
                                                    <h6 class="pro-details__info-name">
                                                        Hatch Time
                                                    </h6>
                                                    <p class="pro-details__info-value">
                                                        <img alt="Dragon Hatch Time"
                                                            src="/assets/images/common/hatching.png" width="22">
                                                        {{ splitTime(getBaseHatch(dragon)) }}
                                                        / <img alt="Dragon Breed Time"
                                                            src="/assets/images/common/vip_status.png" width="22"> {{
                                                        splitTime(getBaseHatch(dragon, true)) }}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="pro-details__desc">
                        <div class="row flex-lg-row-reverse g-5">
                            <div class="col-lg-8">
                                <div class="pro-details__desc-content">
                                    <div data-bs-spy="scroll" data-bs-target="#pro-details-navlist"
                                        data-bs-smooth-scroll="true" data-bs-root-margin="0px 0px -60%"
                                        class="scrollspy-example" tabindex="0">

                                        <section id="dragon-about">
                                            <h4>About {{ dragon.name.replaceAll('_', ' ') }} Dragon</h4>
                                            <div style="display: flex; justify-content: space-around;">
                                                <img :src="`/assets/images/dragons/egg/${dragon.name}_Dragon.png`"
                                                    :alt="`${dragon.name}`" width="100" @error="getErrorImg" />
                                                <img :src="`/assets/images/dragons/baby/${dragon.name}_Dragon.png`"
                                                    :alt="`${dragon.name}`" width="100" @error="getErrorImg" />
                                                <img :src="`/assets/images/dragons/adult/${dragon.name}_Dragon.png`"
                                                    :alt="`${dragon.name}`" width="100" @error="getErrorImg" />
                                            </div>
                                        </section>

                                        <section id="dragon-calculation">
                                            <h4>Damage & Sigils Calculation</h4>
                                            <div class="row">
                                                <div class="pro-details__info">
                                                    <div class="row g-2">
                                                        <div class="col-sm-2">
                                                            <div class="pro-details__info-item">
                                                                <h6 class="pro-details__info-name">
                                                                    Current Level
                                                                </h6>
                                                                <div class="pro-details__info-value">
                                                                    <VueMultiselect v-model="calculateLevel"
                                                                        :options="Array.from(Array(126).keys())"
                                                                        :searchable="true" selectLabel=""
                                                                        :hideSelected="true" :allowEmpty="false">
                                                                    </VueMultiselect>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-2">
                                                            <div class="pro-details__info-item">
                                                                <h6 class="pro-details__info-name">
                                                                    Current Stars
                                                                </h6>
                                                                <div class="pro-details__info-value">
                                                                    <VueMultiselect v-model="calculateStar"
                                                                        :options="Array.from(Array(13).keys())"
                                                                        :searchable="true" selectLabel=""
                                                                        :hideSelected="true" :allowEmpty="false">
                                                                    </VueMultiselect>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-2">
                                                            <div class="pro-details__info-item">
                                                                <h6 class="pro-details__info-name">
                                                                    Sigil Type
                                                                </h6>
                                                                <div class="pro-details__info-value">
                                                                    <VueMultiselect v-model="sigilType"
                                                                        :options="sigilTypes" :searchable="true"
                                                                        selectLabel="" :hideSelected="true"
                                                                        :allowEmpty="false">
                                                                    </VueMultiselect>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-3">
                                                            <div class="pro-details__info-item">
                                                                <h6 class="pro-details__info-name">
                                                                    Bonus Damage <img alt="Dragon Attack"
                                                                        src="/assets/images/common/attack.png"
                                                                        width="22">
                                                                </h6>
                                                                <div class="pro-details__info-value">
                                                                    {{ numberFormat(getGrowthAttack(true) + damageBonus)
                                                                    }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-3">
                                                            <div class="pro-details__info-item">
                                                                <h6 class="pro-details__info-name">
                                                                    Bonus Health <img alt="Dragon Health"
                                                                        src="/assets/images/common/breeding.png"
                                                                        width="22">
                                                                </h6>
                                                                <p class="pro-details__info-value">
                                                                    {{ numberFormat(getGrowthHP(true) + healthBonus) }}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col col-md-4">
                                                    <div class="mt-4" style="display: flex; justify-content: center;">
                                                        <div v-html="dragonStar"></div>
                                                    </div>
                                                    <div class="mt-4" style="display: flex; justify-content: center;">
                                                        <div class="product__remove">
                                                            <img v-if="firstSigil.name"
                                                                :src="`/assets/images/sigils/${jsUcfirst(firstSigil.name)}_${firstSigil.type}.png`"
                                                                width="50" @click="removeSigil('first')"
                                                                class="select-sigil">
                                                            <img v-else
                                                                :src="`/assets/images/sigils/116px-Sigil_Trinket_Icon.png`"
                                                                width="50">
                                                        </div>
                                                        &nbsp;&nbsp;
                                                        <div>
                                                            <img v-if="secondSigil.name"
                                                                :src="`/assets/images/sigils/${jsUcfirst(secondSigil.name)}_${secondSigil.type}.png`"
                                                                width="50" @click="removeSigil('second')"
                                                                class="select-sigil">
                                                            <img v-else
                                                                :src="`/assets/images/sigils/116px-Sigil_Trinket_Icon.png`"
                                                                width="50">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col col-md-8">
                                                    <div class="mt-5" id="list_sigils" v-if="sigilType"
                                                        style="flex-wrap: wrap; display: flex; justify-content: space-around;">
                                                        <span v-for="(sigil, key) in Object.keys(sigils)"
                                                            :key="sigil+key" @click="setSigil(sigils[sigil])"
                                                            class="select-sigil"
                                                            :class="{ 'selected-sigil': (jsUcfirst(sigil) == firstSigil.name || jsUcfirst(sigil) == secondSigil.name) }">
                                                            <img :src="`/assets/images/sigils/${jsUcfirst(sigil)}_${sigilType}.png`"
                                                                width="40">
                                                            &nbsp;
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </section>

                                        <section id="dragon-details">
                                            <h4> {{ dragon.name.replaceAll('_', ' ') }} Dragon Details</h4>
                                            <p v-html="dragon.summary"></p>
                                            <p v-html="dragon.obtaining"></p>
                                        </section>

                                        <section id="dragon-related">
                                            <div class="row">
                                                <h4>Random Dragons</h4>

                                                <div class="team__wrapper" v-if="randomDragons.length">
                                                    <div class="row justify-content-center g-4">
                                                        <div class="col-lg-2 col-sm-6"
                                                            v-for="(rl, idx) in randomDragons" :key="idx">
                                                            <div class="team__item">
                                                                <div class="team__thumb">
                                                                    <router-link :to="`/dragons/${rl.name}`">
                                                                        <img :src="`/assets/images/dragons/avatar/${rl.name}_Dragon.png`"
                                                                            width="60" :alt="`${rl.name}`" />
                                                                    </router-link>
                                                                </div>
                                                                <div class="team__content">
                                                                    <h4>
                                                                        <router-link :to="`/dragons/${rl.name}`">
                                                                            {{ rl.name.replaceAll('_', ' ') }}
                                                                        </router-link>
                                                                    </h4>
                                                                    <div>
                                                                        <span v-for="(element, e_idx) in rl.elements"
                                                                            :key="e_idx">
                                                                            <img :src="`/assets/images/elements/${element}.png`"
                                                                                :alt="`${element}`" width="25" />
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </section>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4">
                                <aside>
                                    <div class="pro-details__desc-nav">

                                        <div class="list-group bg--primary-color mb-4" id="pro-details-navlist">
                                            <a class="list-group-item list-group-item-action" href="#dragon-about"><i
                                                    class="fa-solid fa-window-restore"></i>
                                                About</a>
                                            <a class="list-group-item list-group-item-action" href="#dragon-details">
                                                <i class="fa-solid fa-diagram-project"></i> Details</a>
                                            <a class="list-group-item list-group-item-action"
                                                href="#dragon-calculation">
                                                <i class="fa-solid fa-road"></i> Calculation</a>
                                            <a class="list-group-item list-group-item-action" href="#dragon-level-up"><i
                                                    class="fa-solid fa-user-astronaut"></i>
                                                Raising</a>
                                        </div>

                                        <div class="pro-details__links">
                                            <div class="pro-details__links-item">
                                                <div class="pro-details__links-title">
                                                    <h6>Social Media</h6>
                                                </div>
                                                <div class="pro-details__links-content">
                                                    <ul class="social">
                                                        <li class="social__item">
                                                            <a href="#" class="social__link"><i
                                                                    class="fab fa-twitter"></i></a>
                                                        </li>
                                                        <li class="social__item">
                                                            <a href="#" class="social__link"><i
                                                                    class="fab fa-discord"></i></a>
                                                        </li>
                                                        <li class="social__item">
                                                            <a href="#" class="social__link"><i
                                                                    class="fab fa-twitch"></i></a>
                                                        </li>
                                                        <li class="social__item">
                                                            <a href="#" class="social__link"><i
                                                                    class="fab fa-instagram"></i></a>
                                                        </li>
                                                        <li class="social__item">
                                                            <a href="#" class="social__link"><i
                                                                    class="fab fa-linkedin-in"></i></a>
                                                        </li>
                                                        <li class="social__item">
                                                            <a href="#" class="social__link"><i
                                                                    class="fab fa-facebook-f"></i></a>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div class="pro-details__links-item">
                                                <div class="pro-details__links-title">
                                                    <h6>Website Link</h6>
                                                </div>
                                                <div class="pro-details__links-content">
                                                    <router-link class="pro-details__links-btn"
                                                        :to="`/dragons/${dragon.name}`">
                                                        /dragons/{{ dragon.name }}
                                                        <span>
                                                            <i class="fa-solid fa-globe"></i></span>
                                                    </router-link>
                                                </div>
                                            </div>

                                            <div class="pro-details__links-item mb-4">
                                                <div class="pro-details__links-title">
                                                    <h6>Ads</h6>
                                                </div>
                                                <div class="pro-details__links-content text-center">
                                                    <a href="https://themecenter.net" target="_blank">
                                                        <img width="250px"
                                                            src="https://themecenter.net/assets/images/brand/logo1.png">
                                                    </a>
                                                    <br>
                                                    <br>
                                                    <br>
                                                    
                                                </div>
                                            </div>

                                            <div class="pro-details__links-item">
                                                <div class="pro-details__links-title">
                                                    <h6>Level Calculation</h6>
                                                </div>
                                                <div class="pro-details__links-content">
                                                    <div>
                                                        <h5>{{ numberFormat(calculateFoodCost()) }} &nbsp; &nbsp; <img
                                                                src="/assets/images/common/food.png" /></h5>
                                                    </div>
                                                    <div class="row mt-3">
                                                        <div class="col col-md-4">
                                                            <VueMultiselect v-model="currentLevel" :hideSelected="true"
                                                                :options="Array.from(Array(126).keys())"
                                                                :searchable="true">
                                                            </VueMultiselect>
                                                        </div>

                                                        <div class="col col-md-4">
                                                            <VueMultiselect v-model="targetLevel" :hideSelected="true"
                                                                :options="Array.from(Array(126).keys())"
                                                                :searchable="true">
                                                            </VueMultiselect>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="pro-details__links-item">
                                                <div class="pro-details__links-title">
                                                    <h6>Enchantment Calculation</h6>
                                                </div>
                                                <div class="pro-details__links-content">
                                                    <div v-html="htmlMaterials"></div>
                                                    <div class="row mt-3">
                                                        <div class="col col-md-4">
                                                            <VueMultiselect v-model="currentStar" :hideSelected="true"
                                                                :options="Array.from(Array(13).keys())"
                                                                :searchable="true">
                                                            </VueMultiselect>
                                                        </div>

                                                        <div class="col col-md-4">
                                                            <VueMultiselect v-model="targetStar" :hideSelected="true"
                                                                :options="Array.from(Array(13).keys())"
                                                                :searchable="true">
                                                            </VueMultiselect>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </aside>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    /*eslint-disable */
    import VueMultiselect from 'vue-multiselect'

    import _ from 'lodash';
    String.prototype.remove = function (str) {
        return this.replace(str, '');
    };

    String.prototype.contains = function (string) {
        return this.indexOf(string) !== -1;
    };

    String.prototype.capitalize = function () {
        return this[0].toUpperCase() + this.slice(1).toLowerCase();
    };

    export default {
        name: 'Dragon',
        components: {
            VueMultiselect,
        },
        props: {
            dragons: Array,
            elements: Array,
            // skills: Object,
        },
        computed: {

        },
        created() {
            this.dragonName = this.$route.params.dragon.toLowerCase()
            this.dragonName = this.dragonName.replaceAll(' ', '_')
            this.preparedDragons = [...this.dragons]

            this.preparedDragons.map((drg) => {
                let dragonName = drg.name.toLowerCase()
                if (this.dragonName == dragonName) {
                    this.dragon = drg
                    return
                }
            })

            if (undefined == this.dragon.name) {
                window.location.href = "/"
            }

            document.title = `${this.dragon.name.replaceAll('_', ' ')} | Dragon Mania Legends`

            document.head.querySelector("meta[name=description]").content = `${
                this.dragon.name
            } Dragon | How to breed ${
                this.dragon.name
            } Dragon ? | Dragon Mania Legends`

            document.head.querySelector("meta[name=title]").content = `${
                this.dragon.name
            } Dragon | How to breed ${
                this.dragon.name
            } Dragon ? | Dragon Mania Legends`

            document.querySelector("link[rel~='icon']").href = this.getAvatar(this.dragon, 1);

            // this.getReletedDragons()
        },
        data() {
            return {
                preparedDragons: [],
                dragonName: '',
                sigilTypes: ['C', 'U', 'R', 'E', 'L'],
                sigilType: 'L',
                dragon: {},
                randomDragons: [],
                starOptions: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
                foodCostLv: [
                    0, 4, 8, 16, 40, 80, 160, 320, 640, 1280, 2560, 5120, 6400, 8400, 12000, 16000, 20500, 25000,
                    35000, 50000,
                    65000, 82500, 100000, 120000, 150000, 180000, 216000, 252000, 288000, 324000, 364000, 412000,
                    460000,
                    512000, 568000, 632000, 696000, 768000, 844000, 924000, 1012000, 1104000, 1200000, 1304000,
                    1416000,
                    1532000,
                    1656000, 1788000, 1928000, 2072000, 2228000, 2388000, 2560000, 2736000, 2924000, 3120000,
                    3324000, 3540000,
                    3764000, 4000000, 4200000, 4400000, 4600000, 4800000, 5000000, 5200000, 5400000, 5600000,
                    5800000, 6000000,
                    6200000,
                    6400000, 6600000, 6800000, 7000000, 7200000, 7400000, 7600000, 7800000, 8000000, 8000000,
                    8000000, 8000000,
                    8000000, 8000000, 8000000, 8000000, 8000000, 8000000, 8000000, 8000000, 8000000, 8000000,
                    8000000, 8000000,
                    8000000, 8000000, 8000000, 8000000, 8000000,
                    8000000, 8000000, 8000000, 8000000, 8000000,
                    8000000, 8000000, 8000000, 8000000, 8000000,
                    8000000, 8000000, 8000000, 8000000, 8000000,
                    8000000, 8000000, 8000000, 8000000, 8000000
                ],
                costTable: {
                    COMMON: {
                        1: [
                            [{
                                grade2: 14
                            }],
                            [{
                                grade3: 21
                            }],
                            [{
                                grade4: 25
                            }],
                            [{
                                grade5: 28
                            }],
                            [{
                                grade5: 25
                            }],
                            [{
                                grade5: 28
                            }],
                            [{
                                grade5: 32
                            }],
                            [{
                                grade5: 35
                            }],
                            [{
                                grade5: 39
                            }],
                            [{
                                grade5: 42
                            }],
                            [{
                                grade5: 47
                            }],
                            [{
                                grade5: 52
                            }]
                        ],
                        2: [
                            [{
                                grade1: 6
                            }, {
                                grade1: 6
                            }],
                            [{
                                grade3: 6
                            }, {
                                grade1: 12
                            }],
                            [{
                                grade3: 9
                            }, {
                                grade2: 13
                            }],
                            [{
                                grade4: 11
                            }, {
                                grade2: 19
                            }],
                            [{
                                grade5: 7
                            }, {
                                grade3: 14
                            }],
                            [{
                                grade5: 8
                            }, {
                                grade3: 13
                            }],
                            [{
                                grade5: 9
                            }, {
                                grade3: 15
                            }],
                            [{
                                grade5: 10
                            }, {
                                grade5: 10
                            }],
                            [{
                                grade5: 11
                            }, {
                                grade5: 11
                            }],
                            [{
                                grade5: 12
                            }, {
                                grade5: 12
                            }],
                            [{
                                grade5: 13
                            }, {
                                grade5: 13
                            }],
                            [{
                                grade5: 15
                            }, {
                                grade5: 15
                            }],
                        ]
                    },
                    UNCOMMON: {
                        2: [
                            [{
                                grade2: 6
                            }, {
                                grade1: 9
                            }],
                            [{
                                grade3: 9
                            }, {
                                grade2: 14
                            }],
                            [{
                                grade4: 11
                            }, {
                                grade3: 14
                            }],
                            [{
                                grade5: 12
                            }, {
                                grade3: 21
                            }],
                            [{
                                grade5: 11
                            }, {
                                grade3: 21
                            }],
                            [{
                                grade5: 12
                            }, {
                                grade4: 20
                            }],
                            [{
                                grade5: 14
                            }, {
                                grade5: 14
                            }],
                            [{
                                grade5: 15
                            }, {
                                grade5: 15
                            }],
                            [{
                                grade5: 16
                            }, {
                                grade5: 16
                            }],
                            [{
                                grade5: 18
                            }, {
                                grade5: 18
                            }],
                            [{
                                grade5: 20
                            }, {
                                grade5: 20
                            }],
                            [{
                                grade5: 22
                            }, {
                                grade5: 22
                            }]
                        ]
                    },
                    RARE: {
                        2: [
                            [{
                                grade2: 10
                            }, {
                                grade1: 15
                            }],
                            [{
                                grade3: 15
                            }, {
                                grade2: 23
                            }],
                            [{
                                grade4: 18
                            }, {
                                grade3: 23
                            }],
                            [{
                                grade5: 20
                            }, {
                                grade4: 28
                            }],
                            [{
                                grade5: 18
                            }, {
                                grade4: 28
                            }],
                            [{
                                grade5: 20
                            }, {
                                grade5: 20
                            }],
                            [{
                                grade5: 23
                            }, {
                                grade5: 23
                            }],
                            [{
                                grade5: 25
                            }, {
                                grade5: 25
                            }],
                            [{
                                grade5: 28
                            }, {
                                grade5: 28
                            }],
                            [{
                                grade5: 30
                            }, {
                                grade5: 30
                            }],
                            [{
                                grade5: 33
                            }, {
                                grade5: 33
                            }],
                            [{
                                grade5: 37
                            }, {
                                grade5: 37
                            }]
                        ],
                        3: [
                            [{
                                grade2: 10
                            }, {
                                grade1: 15
                            }, {
                                grade1: 15
                            }],
                            [{
                                grade3: 15
                            }, {
                                grade2: 23
                            }, {
                                grade1: 30
                            }],
                            [{
                                grade4: 18
                            }, {
                                grade3: 23
                            }, {
                                grade2: 33
                            }],
                            [{
                                grade5: 20
                            }, {
                                grade4: 28
                            }, {
                                grade3: 35
                            }],
                            [{
                                grade5: 18
                            }, {
                                grade4: 28
                            }, {
                                grade4: 28
                            }],
                            [{
                                grade5: 20
                            }, {
                                grade5: 20
                            }, {
                                grade4: 33
                            }],
                            [{
                                grade5: 23
                            }, {
                                grade5: 23
                            }, {
                                grade5: 23
                            }],
                            [{
                                grade5: 25
                            }, {
                                grade5: 25
                            }, {
                                grade5: 25
                            }],
                            [{
                                grade5: 28
                            }, {
                                grade5: 28
                            }, {
                                grade5: 28
                            }],
                            [{
                                grade5: 30
                            }, {
                                grade5: 30
                            }, {
                                grade5: 30
                            }],
                            [{
                                grade5: 33
                            }, {
                                grade5: 33
                            }, {
                                grade5: 33
                            }],
                            [{
                                grade5: 37
                            }, {
                                grade5: 37
                            }, {
                                grade5: 37
                            }]
                        ]
                    },
                    EPIC: {
                        2: [
                            [{
                                grade2: 14
                            }, {
                                grade2: 14
                            }],
                            [{
                                grade3: 21
                            }, {
                                grade2: 32
                            }],
                            [{
                                grade4: 25
                            }, {
                                grade4: 25
                            }],
                            [{
                                grade5: 28
                            }, {
                                grade5: 28
                            }],
                            [{
                                grade5: 23
                            }, {
                                grade5: 23
                            }],
                            [{
                                grade5: 25
                            }, {
                                grade5: 25
                            }],
                            [{
                                grade5: 27
                            }, {
                                grade5: 27
                            }],
                            [{
                                grade5: 30
                            }, {
                                grade5: 30
                            }]
                        ],
                        3: [
                            [{
                                grade2: 14
                            }, {
                                grade2: 14
                            }, {
                                grade2: 14
                            }],
                            [{
                                grade3: 21
                            }, {
                                grade2: 32
                            }, {
                                grade1: 32
                            }],
                            [{
                                grade4: 25
                            }, {
                                grade4: 25
                            }, {
                                grade3: 32
                            }],
                            [{
                                grade5: 28
                            }, {
                                grade5: 28
                            }, {
                                grade4: 39
                            }],
                            [{
                                grade5: 23
                            }, {
                                grade5: 23
                            }, {
                                grade5: 23
                            }],
                            [{
                                grade5: 25
                            }, {
                                grade5: 25
                            }, {
                                grade5: 25
                            }],
                            [{
                                grade5: 27
                            }, {
                                grade5: 27
                            }, {
                                grade5: 27
                            }],
                            [{
                                grade5: 30
                            }, {
                                grade5: 30
                            }, {
                                grade5: 30
                            }],
                            [{
                                grade5: 33
                            }, {
                                grade5: 33
                            }, {
                                grade5: 33
                            }],
                            [{
                                grade5: 36
                            }, {
                                grade5: 36
                            }, {
                                grade5: 36
                            }],
                            [{
                                grade5: 40
                            }, {
                                grade5: 40
                            }, {
                                grade5: 40
                            }],
                            [{
                                grade5: 44
                            }, {
                                grade5: 44
                            }, {
                                grade5: 44
                            }]
                        ]
                    },
                    LEGENDARY: {
                        3: [
                            [{
                                grade3: 12
                            }, {
                                grade2: 16
                            }, {
                                grade1: 24
                            }],
                            [{
                                grade4: 16
                            }, {
                                grade3: 24
                            }, {
                                grade2: 36
                            }],
                            [{
                                grade5: 16
                            }, {
                                grade4: 28
                            }, {
                                grade3: 36
                            }],
                            [{
                                grade5: 32
                            }, {
                                grade5: 32
                            }, {
                                grade5: 32
                            }],
                            [{
                                grade5: 21
                            }, {
                                grade5: 22
                            }, {
                                grade5: 22
                            }],
                            [{
                                grade5: 22
                            }, {
                                grade5: 24
                            }, {
                                grade5: 24
                            }],
                            [{
                                grade5: 23
                            }, {
                                grade5: 27
                            }, {
                                grade5: 27
                            }],
                            [{
                                grade5: 25
                            }, {
                                grade5: 30
                            }, {
                                grade5: 30
                            }],
                            [{
                                grade5: 28
                            }, {
                                grade5: 33
                            }, {
                                grade5: 33
                            }],
                            [{
                                grade5: 30
                            }, {
                                grade5: 36
                            }, {
                                grade5: 36
                            }],
                            [{
                                grade5: 33
                            }, {
                                grade5: 40
                            }, {
                                grade5: 40
                            }],
                            [{
                                grade5: 37
                            }, {
                                grade5: 44
                            }, {
                                grade5: 44
                            }]
                        ]
                    },
                    DIVINE: {
                        3: [
                            [{
                                grade3: 15
                            }, {
                                grade2: 20
                            }, {
                                grade1: 24
                            }],
                            [{
                                grade4: 20
                            }, {
                                grade3: 30
                            }, {
                                grade2: 45
                            }],
                            [{
                                grade5: 20
                            }, {
                                grade4: 35
                            }, {
                                grade3: 45
                            }],
                            [{
                                grade5: 40
                            }, {
                                grade5: 40
                            }, {
                                grade5: 40
                            }],
                            [{
                                grade5: 21
                            }, {
                                grade5: 28
                            }, {
                                grade5: 28
                            }],
                            [{
                                grade5: 22
                            }, {
                                grade5: 30
                            }, {
                                grade5: 30
                            }],
                            [{
                                grade5: 23
                            }, {
                                grade5: 32
                            }, {
                                grade5: 32
                            }],
                            [{
                                grade5: 25
                            }, {
                                grade5: 35
                            }, {
                                grade5: 35
                            }],
                            [{
                                grade5: 28
                            }, {
                                grade5: 39
                            }, {
                                grade5: 39
                            }],
                            [{
                                grade5: 30
                            }, {
                                grade5: 42
                            }, {
                                grade5: 42
                            }],
                            [{
                                grade5: 33
                            }, {
                                grade5: 47
                            }, {
                                grade5: 47
                            }],
                            [{
                                grade5: 37
                            }, {
                                grade5: 52
                            }, {
                                grade5: 52
                            }]
                        ]
                    },
                    ANCIENT: {
                        3: [
                            [{
                                grade3: 15
                            }, {
                                grade2: 20
                            }, {
                                grade1: 24
                            }],
                            [{
                                grade4: 20
                            }, {
                                grade3: 30
                            }, {
                                grade2: 45
                            }],
                            [{
                                grade5: 20
                            }, {
                                grade4: 35
                            }, {
                                grade3: 45
                            }],
                            [{
                                grade5: 40
                            }, {
                                grade5: 40
                            }, {
                                grade5: 40
                            }],
                            [{
                                grade5: 21
                            }, {
                                grade5: 28
                            }, {
                                grade5: 28
                            }],
                            [{
                                grade5: 22
                            }, {
                                grade5: 30
                            }, {
                                grade5: 30
                            }],
                            [{
                                grade5: 23
                            }, {
                                grade5: 32
                            }, {
                                grade5: 32
                            }],
                            [{
                                grade5: 25
                            }, {
                                grade5: 35
                            }, {
                                grade5: 35
                            }],
                            [{
                                grade5: 28
                            }, {
                                grade5: 39
                            }, {
                                grade5: 39
                            }],
                            [{
                                grade5: 30
                            }, {
                                grade5: 42
                            }, {
                                grade5: 42
                            }],
                            [{
                                grade5: 33
                            }, {
                                grade5: 47
                            }, {
                                grade5: 47
                            }],
                            [{
                                grade5: 37
                            }, {
                                grade5: 52
                            }, {
                                grade5: 52
                            }]
                        ]
                    },
                    PRIMAL: {
                        3: [
                            [{
                                grade3: 15
                            }, {
                                grade2: 20
                            }, {
                                grade1: 24
                            }],
                            [{
                                grade4: 20
                            }, {
                                grade3: 30
                            }, {
                                grade2: 45
                            }],
                            [{
                                grade5: 20
                            }, {
                                grade4: 35
                            }, {
                                grade3: 45
                            }],
                            [{
                                grade5: 40
                            }, {
                                grade5: 40
                            }, {
                                grade5: 40
                            }],
                            [{
                                grade5: 21
                            }, {
                                grade5: 28
                            }, {
                                grade5: 28
                            }],
                            [{
                                grade5: 22
                            }, {
                                grade5: 30
                            }, {
                                grade5: 30
                            }],
                            [{
                                grade5: 23
                            }, {
                                grade5: 32
                            }, {
                                grade5: 32
                            }],
                            [{
                                grade5: 25
                            }, {
                                grade5: 35
                            }, {
                                grade5: 35
                            }],
                            [{
                                grade5: 28
                            }, {
                                grade5: 39
                            }, {
                                grade5: 39
                            }],
                            [{
                                grade5: 30
                            }, {
                                grade5: 42
                            }, {
                                grade5: 42
                            }],
                            [{
                                grade5: 33
                            }, {
                                grade5: 47
                            }, {
                                grade5: 47
                            }],
                            [{
                                grade5: 37
                            }, {
                                grade5: 52
                            }, {
                                grade5: 52
                            }]
                        ]
                    },
                    TYRANT: {
                    3: [
                        [{
                            grade3: 15
                        }, {
                            grade2: 20
                        }, {
                            grade1: 24
                        }],
                        [{
                            grade4: 20
                        }, {
                            grade3: 30
                        }, {
                            grade2: 45
                        }],
                        [{
                            grade5: 20
                        }, {
                            grade4: 35
                        }, {
                            grade3: 45
                        }],
                        [{
                            grade5: 40
                        }, {
                            grade5: 40
                        }, {
                            grade5: 40
                        }],
                        [{
                            grade5: 21
                        }, {
                            grade5: 28
                        }, {
                            grade5: 28
                        }],
                        [{
                            grade5: 22
                        }, {
                            grade5: 30
                        }, {
                            grade5: 30
                        }],
                        [{
                            grade5: 23
                        }, {
                            grade5: 32
                        }, {
                            grade5: 32
                        }],
                        [{
                            grade5: 25
                        }, {
                            grade5: 35
                        }, {
                            grade5: 35
                        }],
                        [{
                            grade5: 28
                        }, {
                            grade5: 39
                        }, {
                            grade5: 39
                        }],
                        [{
                            grade5: 30
                        }, {
                            grade5: 42
                        }, {
                            grade5: 42
                        }],
                        [{
                            grade5: 33
                        }, {
                            grade5: 47
                        }, {
                            grade5: 47
                        }],
                        [{
                            grade5: 37
                        }, {
                            grade5: 52
                        }, {
                            grade5: 52
                        }]
                    ]
                },
                    SUPREME: {
                        3: [
                            [{
                                grade3: 15
                            }, {
                                grade2: 20
                            }, {
                                grade1: 24
                            }],
                            [{
                                grade4: 20
                            }, {
                                grade3: 30
                            }, {
                                grade2: 45
                            }],
                            [{
                                grade5: 20
                            }, {
                                grade4: 35
                            }, {
                                grade3: 45
                            }],
                            [{
                                grade5: 40
                            }, {
                                grade5: 40
                            }, {
                                grade5: 40
                            }],
                            [{
                                grade5: 21
                            }, {
                                grade5: 28
                            }, {
                                grade5: 28
                            }],
                            [{
                                grade5: 22
                            }, {
                                grade5: 30
                            }, {
                                grade5: 30
                            }],
                            [{
                                grade5: 23
                            }, {
                                grade5: 32
                            }, {
                                grade5: 32
                            }],
                            [{
                                grade5: 25
                            }, {
                                grade5: 35
                            }, {
                                grade5: 35
                            }],
                            [{
                                grade5: 28
                            }, {
                                grade5: 39
                            }, {
                                grade5: 39
                            }],
                            [{
                                grade5: 30
                            }, {
                                grade5: 42
                            }, {
                                grade5: 42
                            }],
                            [{
                                grade5: 33
                            }, {
                                grade5: 47
                            }, {
                                grade5: 47
                            }],
                            [{
                                grade5: 37
                            }, {
                                grade5: 52
                            }, {
                                grade5: 52
                            }]
                        ]
                    },

                },
                currentStar: 1,
                targetStar: 5,
                currentLevel: 10,
                targetLevel: 120,
                htmlMaterials: '',
                attackValues: {
                    FIRE: 3.0,
                    WIND: 1.8,
                    EARTH: -1.8,
                    WATER: 0,
                    PLANT: 1.2,
                    METAL: -1.8,
                    ENERGY: 5.4,
                    VOID: 2.4,
                    LIGHT: 3.0,
                    SHADOW: 6.0,
                    LEGENDARY: 12.0,
                    DIVINE: 13.8,
                    ANCIENT: 15,
                    PRIMAL: 12,
                    TYRANT: 12,
                },
                hpValues: {
                    FIRE: -6,
                    WIND: -2,
                    EARTH: 14,
                    WATER: 10,
                    PLANT: 8,
                    METAL: 16,
                    ENERGY: -8,
                    VOID: 6,
                    LIGHT: 8,
                    SHADOW: -6,
                    LEGENDARY: 40,
                    DIVINE: 42,
                    ANCIENT: 45,
                    PRIMAL: 41,
                    TYRANT: 49,
                },
                sigils: {
                    wonder: {
                        name: 'Wonder',
                        hp_C: 25,
                        hp_U: 115,
                        hp_R: 195,
                        hp_E: 395,
                        hp_L: 650,
                        dame_C: 5,
                        dame_U: 15,
                        dame_R: 65,
                        dame_E: 120,
                        dame_L: 200,
                        group: 'growth'
                    },
                    mirror: {
                        name: 'Mirror',
                        hp_C: 25,
                        hp_U: 115,
                        hp_R: 195,
                        hp_E: 395,
                        hp_L: 650,
                        dame_C: 5,
                        dame_U: 40,
                        dame_R: 100,
                        dame_E: 235,
                        dame_L: 450,
                        group: 'growth'
                    },
                    turtle: {
                        name: 'Turtle',
                        hp_C: 25,
                        hp_U: 135,
                        hp_R: 240,
                        hp_E: 500,
                        hp_L: 850,
                        dame_C: 5,
                        dame_U: 10,
                        dame_R: 30,
                        dame_E: 50,
                        dame_L: 120,
                        group: 'growth'
                    },
                    berserker: {
                        name: 'Berserker',
                        hp_C: 25,
                        hp_U: 100,
                        hp_R: 170,
                        hp_E: 360,
                        hp_L: 600,
                        dame_C: 5,
                        dame_U: 40,
                        dame_R: 95,
                        dame_E: 185,
                        dame_L: 350,
                        group: 'growth'
                    },
                    chi: {
                        name: 'Chi',
                        hp_C: 25,
                        hp_U: 115,
                        hp_R: 195,
                        hp_E: 395,
                        hp_L: 650,
                        dame_C: 5,
                        dame_U: 40,
                        dame_R: 100,
                        dame_E: 235,
                        dame_L: 450,
                        group: 'growth'
                    },
                    acceptance: {
                        name: 'Acceptance',
                        hp_C: 25,
                        hp_U: 100,
                        hp_R: 170,
                        hp_E: 360,
                        hp_L: 600,
                        dame_C: 5,
                        dame_U: 20,
                        dame_R: 65,
                        dame_E: 120,
                        dame_L: 200,
                        group: 'power'
                    },
                    witchcraft: {
                        name: 'Witchcraft',
                        hp_C: 25,
                        hp_U: 100,
                        hp_R: 170,
                        hp_E: 360,
                        hp_L: 600,
                        dame_C: 5,
                        dame_U: 40,
                        dame_R: 95,
                        dame_E: 185,
                        dame_L: 350,
                        group: 'power'
                    },
                    daredevil: {
                        name: 'Daredevil',
                        hp_C: 25,
                        hp_U: 75,
                        hp_R: 110,
                        hp_E: 300,
                        hp_L: 550,
                        dame_C: 5,
                        dame_U: 15,
                        dame_R: 20,
                        dame_E: 35,
                        dame_L: 70,
                        group: 'power'
                    },
                    cruelty: {
                        name: 'Cruelty',
                        hp_C: 25,
                        hp_U: 75,
                        hp_R: 110,
                        hp_E: 300,
                        hp_L: 550,
                        dame_C: 5,
                        dame_U: 7,
                        dame_R: 10,
                        dame_E: 12,
                        dame_L: 15,
                        group: 'power'
                    },
                    evasion: {
                        name: 'Evasion',
                        hp_C: 25,
                        hp_U: 115,
                        hp_R: 195,
                        hp_E: 395,
                        hp_L: 650,
                        dame_C: 5,
                        dame_U: 40,
                        dame_R: 100,
                        dame_E: 235,
                        dame_L: 450,
                        group: 'power'
                    },
                    subdue: {
                        name: 'Subdue',
                        hp_C: 25,
                        hp_U: 100,
                        hp_R: 170,
                        hp_E: 360,
                        hp_L: 600,
                        dame_C: 5,
                        dame_U: 40,
                        dame_R: 95,
                        dame_E: 185,
                        dame_L: 350,
                        group: 'shelter'
                    },
                    defiance: {
                        name: 'Defiance',
                        hp_C: 25,
                        hp_U: 115,
                        hp_R: 195,
                        hp_E: 395,
                        hp_L: 650,
                        dame_C: 5,
                        dame_U: 40,
                        dame_R: 95,
                        dame_E: 185,
                        dame_L: 350,
                        group: 'shelter'
                    },
                    havoc: {
                        name: 'Havoc',
                        hp_C: 25,
                        hp_U: 75,
                        hp_R: 110,
                        hp_E: 300,
                        hp_L: 550,
                        dame_C: 5,
                        dame_U: 15,
                        dame_R: 30,
                        dame_E: 35,
                        dame_L: 70,
                        group: 'shelter'
                    },
                    rebirth: {
                        name: 'Rebirth',
                        hp_C: 25,
                        hp_U: 100,
                        hp_R: 170,
                        hp_E: 360,
                        hp_L: 600,
                        dame_C: 5,
                        dame_U: 10,
                        dame_R: 30,
                        dame_E: 50,
                        dame_L: 120,
                        group: 'shelter'
                    },
                    purity: {
                        name: 'Purity',
                        hp_C: 25,
                        hp_U: 75,
                        hp_R: 110,
                        hp_E: 300,
                        hp_L: 550,
                        dame_C: 5,
                        dame_U: 7,
                        dame_R: 10,
                        dame_E: 12,
                        dame_L: 15,
                        group: 'shelter'
                    },
                },
                berserker: {
                    C: {
                        '1': 84,
                        '25': 50,
                        '50': 16
                    },
                    U: {
                        '1': 250,
                        '25': 150,
                        '50': 50
                    },
                    R: {
                        '1': 556,
                        '25': 336,
                        '50': 115
                    },
                    E: {
                        '1': 1010,
                        '25': 607,
                        '50': 204
                    },
                    L: {
                        '1': 1705,
                        '25': 1021,
                        '50': 337
                    },
                },
                purity: {
                    C: {
                        '25': 18,
                        '50': 53,
                        '75': 88
                    },
                    U: {
                        '25': 53,
                        '50': 155,
                        '75': 257
                    },
                    R: {
                        '25': 95,
                        '50': 294,
                        '75': 494
                    },
                    E: {
                        '25': 192,
                        '50': 294,
                        '75': 966
                    },
                    L: {
                        '25': 393,
                        '50': 1139,
                        '75': 1895
                    },
                },
                daredevil: {
                    C: 79,
                    U: 194,
                    R: 394,
                    E: 790,
                    L: 1471
                },
                firstSigil: {},
                secondSigil: {},
                damageBonus: 0,
                healthBonus: 0,
                calculateLevel: 100,
                calculateStar: 10,
                goldElementValues: {
                    FIRE: 30,
                    WIND: 20,
                    EARTH: 30,
                    WATER: 0,
                    PLANT: 60,
                    METAL: 75,
                    ENERGY: 100,
                    VOID: 140,
                    LIGHT: 180,
                    SHADOW: 180,
                    LEGENDARY: 200,
                    PRIMAL: 200,
                    DIVINE: 220,
                    ANCIENT: 220,
                    TYRANT: 220,
                },
                goldTypeValues: {
                    COMMON: 180,
                    UNCOMMON: 190,
                    RARE: 250,
                    EPIC: 300,
                    LEGENDARY: 450,
                    PRIMAL: 450,
                    DIVINE: 550,
                    ANCIENT: 550,
                    TYRANT: 550,
                },
                breedElementValues: {
                    FIRE: 2,
                    WIND: 2,
                    EARTH: 2,
                    WATER: 2,
                    PLANT: 4,
                    METAL: 4,
                    ENERGY: 6,
                    VOID: 6,
                    LIGHT: 8,
                    SHADOW: 8,
                    LEGENDARY: 48,
                    PRIMAL: 0,
                    DIVINE: 0,
                    ANCIENT: 0,
                    TYRANT: 0,
                },
                breedTypeValues: {
                    COMMON: 0,
                    UNCOMMON: 2,
                    RARE: 6,
                    EPIC: 8,
                    LEGENDARY: 48,
                    PRIMAL: 48,
                    DIVINE: 96,
                    ANCIENT: 96,
                    TYRANT: 96,
                },
                hatchElementValues: {
                    FIRE: 1.6,
                    WIND: 1.6,
                    EARTH: 1.6,
                    WATER: 1.6,
                    PLANT: 1.2,
                    METAL: 1.2,
                    ENERGY: 1.2,
                    VOID: 1.2,
                    LIGHT: 1.1,
                    SHADOW: 1.1,
                    LEGENDARY: 1.2,
                    PRIMAL: 1.2,
                    DIVINE: 1.2,
                    ANCIENT: 1.2,
                    TYRANT: 1.2,
                },
            }
        },
        mounted() {
            window.scrollTo(0, 0)

            this.calculateMaterials()
            this.calculate()

            // const adsbygoogle = window.adsbygoogle || []

            /* setTimeout(() => {
                adsbygoogle.push({});
            }, 2000)

            setTimeout(() => {
                adsbygoogle.push({});
            }, 2000) */

            this.prepareRandomDragons()
        },
        watch: {
            currentStar() {
                this.calculateMaterials()
            },
            targetStar() {
                this.calculateMaterials()
            },
            calculateLevel() {
                this.calculate()
            },
            calculateStar() {
                this.calculate()
            },
        },
        methods: {
            getRandomDragon() {
                return this.preparedDragons[Math.floor(Math.random() * this.preparedDragons.length)]
            },
            prepareRandomDragons() {
                this.randomDragons.push(this.getRandomDragon())
                this.randomDragons.push(this.getRandomDragon())
                this.randomDragons.push(this.getRandomDragon())
                this.randomDragons.push(this.getRandomDragon())
                this.randomDragons.push(this.getRandomDragon())
                this.randomDragons.push(this.getRandomDragon())
            },
            getFoodsWithLv(level) {
                let foods = 0;

                for (let i = 0; i < level; i++) {
                    foods += this.foodCostLv[i]
                }

                return foods;
            },
            calculateFoodCost() {
                var oldLevel = this.currentLevel || 1
                var newLevel = this.targetLevel || 120

                if (newLevel < oldLevel || newLevel == '' || oldLevel == '') {
                    return 0;
                }
                if (newLevel > 125) {
                    newLevel = 125
                }
                if (oldLevel < 1) {
                    oldLevel = 1
                }

                return this.getFoodsWithLv(newLevel) - this.getFoodsWithLv(oldLevel)
            },
            getAvatar(dragon) {
                let name = dragon.name
                return `/assets/images/dragons/avatar/${name}_Dragon.png`
            },
            getErrorImg(event) {
                event.target.src = `/assets/images/dragons/adult/unknown_dragon.png`
            },
            getReletedDragons() {
                const pos = this.preparedDragons.indexOf(this.dragon)

                for (let i = pos - 1; i < pos + 3; i++) {
                    if (this.preparedDragons[i] && this.preparedDragons[i].id != this.dragon.id) {
                        this.randomDragons.push(this.preparedDragons[i])
                    }
                }
            },
            prepareStar(star) {
                let starImg = 'Enchantment_Star_Base'
                let oldStarImg = '16px-Enchantment_Star_(Gray)'

                if (star > 4 && star < 9) {
                    starImg = 'Enchantment_Star_Purple_2'
                    oldStarImg = '18px-Enchantment_Star_(Golden_Empty)'
                } else if (star > 8) {
                    starImg = 'Enchantment_Star_Red'
                    oldStarImg = '20px-Enchantment_Star_(Purple_Empty)'
                }

                let starHtml = ''
                let activeStar = star % 4
                let inactiveStar = star ? 0 : 4

                if (activeStar) {
                    inactiveStar = 4 - activeStar
                } else if (star !== 0) {
                    activeStar = 4
                }

                for (let i = 0; i < activeStar; i++) {
                    starHtml += `<img src="/assets/images/enchantments/${starImg}.png">&nbsp;`
                }

                for (let i = 0; i < inactiveStar; i++) {
                    starHtml += `<img src="/assets/images/enchantments/${oldStarImg}.png">&nbsp;`
                }

                this.dragonStar = starHtml
            },
            setSigil(sigil) {
                if (sigil.name === this.firstSigil.name || sigil.name === this.secondSigil.name) {
                    return
                }

                if (!this.firstSigil.group) {
                    this.firstSigil = sigil
                    this.firstSigil.type = this.sigilType

                    this.calculate()
                    return
                }

                if (!this.secondSigil.group) {
                    this.secondSigil = sigil
                    this.secondSigil.type = this.sigilType

                    this.calculate()
                    return
                }
            },
            removeSigil(type) {
                if (type == 'first') {
                    this.firstSigil = {}
                } else {
                    this.secondSigil = {}
                }

                this.calculate()
            },
            jsUcfirst(string) {
                return string.charAt(0).toUpperCase() + string.slice(1);
            },
            calculate() {
                this.prepareStar(this.calculateStar)

                this.dragon.star = this.calculateStar
                this.dragon.level = this.calculateLevel + this.calculateStar * 2

                this.calculateSigil()
            },
            calculateSigil() {
                let bonusDame = 0
                let bonusHP = 0
                let currentHP = '' + this.currentHP

                if (this.firstSigil.group) {
                    const dame = 'dame_' + this.firstSigil.type
                    const hp = 'hp_' + this.firstSigil.type
                    bonusDame += this.firstSigil[dame]
                    bonusHP += this.firstSigil[hp]
                }

                if (this.secondSigil.group) {
                    const dame = 'dame_' + this.secondSigil.type
                    const hp = 'hp_' + this.secondSigil.type
                    bonusDame += this.secondSigil[dame]
                    bonusHP += this.secondSigil[hp]
                }

                const firstSigilType = '' + this.firstSigil.type
                const secondSigilType = '' + this.secondSigil.type

                if (this.firstSigil.name == 'Berserker') {
                    const newBonusDame = this.berserker[firstSigilType][currentHP] || 0
                    bonusDame += newBonusDame
                }

                if (this.secondSigil.name == 'Berserker') {
                    const newBonusDame = this.berserker[secondSigilType][currentHP] || 0
                    bonusDame += newBonusDame
                }

                if (this.firstSigil.name == 'Purity') {
                    const newBonusDame = this.purity[firstSigilType][currentHP] || 0
                    bonusDame += newBonusDame
                }

                if (this.secondSigil.name == 'Purity') {
                    const newBonusDame = this.purity[secondSigilType][currentHP] || 0
                    bonusDame += newBonusDame
                }

                if (this.firstSigil.name == 'Daredevil') {
                    bonusDame += this.daredevil[firstSigilType]
                }

                if (this.secondSigil.name == 'Daredevil') {
                    bonusDame += this.daredevil[secondSigilType]
                }

                if (bonusDame || bonusHP) {
                    const totalBonusDame = Math.round(this.getGrowthAttack(true) * bonusDame / 100)
                    const totalBonusHP = Math.round(this.getGrowthHP(true) * bonusHP / 100)

                    this.damageBonus = totalBonusDame || 0
                    this.healthBonus = totalBonusHP || 0

                    return
                }

                this.damageBonus = 0
                this.healthBonus = 0
            },
            numberFormat(number) {
                if (number) {
                    return number.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
                }

                return number;
            },
            getBaseAttack(dragon) {
                const elements = dragon.elements
                const el1 = this.attackValues[elements[0]]
                const el2 = elements[1] ? this.attackValues[elements[1]] : 0
                const el3 = elements[2] ? this.attackValues[elements[2]] : 0

                return Math.round(60 + (el1 + el2 + el3)) || 0
            },
            getBaseHP(dragon) {
                const elements = dragon.elements
                const el1 = this.hpValues[elements[0]]
                const el2 = elements[1] ? this.hpValues[elements[1]] : 0
                const el3 = elements[2] ? this.hpValues[elements[2]] : 0

                return Math.round(200 + (el1 + el2 + el3)) || 0
            },
            getGrowthAttack(original) {
                var dragon = this.dragon
                let level = dragon.level || 1
                let star = dragon.star || 0
                level += star * 2

                let attack = Math.round(60 * 1.2 ** (level - 1)) * (this.getBaseAttack(dragon) / 60)

                if (original) {
                    return Math.round(attack)
                }

                return this.numberFormat(Math.round(attack))
            },
            getGrowthHP(original) {
                var dragon = this.dragon
                let level = dragon.level || 1
                let star = dragon.star || 0
                level += star * 2

                let attack = Math.round(200 * 1.2 ** (level - 1)) * (this.getBaseHP(dragon) / 200)

                if (original) {
                    return Math.round(attack)
                }

                return this.numberFormat(Math.round(attack))
            },
            calculateMaterials() {
                var dragon = this.dragon

                if (!dragon) {
                    return
                }

                if (this.currentStar > this.targetStar) {
                    return
                }

                this.htmlMaterials = ''

                if (dragon.type == 'BOSS') {
                    return
                }

                var elements = dragon.elements //[dragon.element1, dragon.element2, dragon.element3].filter(e => e);
                var costTable = this.costTable;
                var data = {};

                costTable[dragon.type][elements.length].slice(this.currentStar, this.targetStar)
                    .forEach(step => {
                        step.forEach((material, index) => {
                            _.each(material, (amount, grade) => {
                                var elementName = elements[index];
                                var gradeLevel = Number(grade.remove('grade'));
                                var materialId = `${elementName}_${gradeLevel}`;

                                if (!data[elementName]) {
                                    data[elementName] = [];
                                    data[elementName][materialId] = 0;
                                } else if (!data[elementName][materialId]) {
                                    data[elementName][materialId] = 0;
                                }

                                data[elementName][materialId] += amount;
                            });
                        });
                    });

                return this.prepareMaterialsHTML(data);
            },
            prepareMaterialsHTML(data) {
                var html = "";

                Object.keys(data).forEach((ele) => {
                    Object.keys(data[ele]).forEach((element) => {
                        let amount = data[ele][element]
                        html += "<span class='font-size-20'>" + amount +
                            " <img width='30' src='/assets/images/enchantments/" + element +
                            ".png' alt='Materials Enchantment'/> </span>";
                    })

                    html += "<br/>"
                })

                this.htmlMaterials = html
                return html;
            },
            getBaseGold(dragon) {
                const type = this.goldTypeValues[dragon.type] || 0
                const elements = dragon.elements
                const el1 = this.goldElementValues[elements[0]]
                const el2 = elements[1] ? this.goldElementValues[elements[1]] : 0
                const el3 = elements[2] ? this.goldElementValues[elements[2]] : 0

                return type + el1 + el2 + el3
            },
            getBaseBreed(dragon, isVip) {
                const type = this.breedTypeValues[dragon.type] || 0

                if (dragon.type == 'LEGENDARY') {
                    return isVip ? 48 * 0.8 : 48
                }

                const elements = dragon.elements
                const el1 = this.breedElementValues[elements[0]]
                const el2 = elements[1] ? this.breedElementValues[elements[1]] : 0
                const el3 = elements[2] ? this.breedElementValues[elements[2]] : 0
                const totalHour = type + el1 + el2 + el3
                return isVip ? totalHour * 0.8 : totalHour
            },
            getBaseHatch(dragon, isVip) {
                const breedTime = this.getBaseBreed(dragon, isVip) * 60
                const elements = dragon.elements
                const el1 = this.hatchElementValues[elements[0]]
                const el2 = elements[1] ? this.hatchElementValues[elements[1]] : 0
                const el3 = elements[2] ? this.hatchElementValues[elements[2]] : 0

                return Math.round(breedTime * (el1 + el2 + el3) / elements.length) / 60
            },
            splitTime(numberOfHours) {
                let Days = Math.floor(numberOfHours / 24);
                let Remainder = numberOfHours % 24;
                let Hours = Math.floor(Remainder);
                let Minutes = Math.floor(60 * (Remainder - Hours))
                let result = ''

                if (Days) {
                    result += `${Days}d`
                }

                if (Hours) {
                    result += ` ${Hours}h`
                }

                if (Minutes) {
                    result += ` ${Minutes}m`
                }

                return result
            },
        }
    }
</script>

<style scoped>
    .select-sigil {
        cursor: pointer;
    }

    .selected-sigil {
        border: 2px dotted #28dbd1;
        border-radius: 15%;
    }
</style>

<style src="vue-multiselect/dist/vue-multiselect.css"></style>